import { useState, useEffect } from "react";
import Header from "../../components/molecules/header/Header"
import Footer from "../../components/molecules/footer/Footer"
import DataTable from "react-data-table-component";
import ConstantesTabla from "../../utils/ConstantesTabla";
import { getPuestos, getPuestosSeleccionados, guardarOrdenPuestos } from "../../components/services/ConcursosService";
import { useNavigate, useParams } from "react-router-dom";

import ModalMensajes from "../../components/molecules/modals/modalMensajes/ModalMensajes";

const SeleccionPuestos = () => {
  const params = useParams();
  const navigate = useNavigate();
  const [puestos, setPuestos] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]); // Para manejar filas seleccionadas con su orden
  const [loading, setLoading] = useState(true);
  const [selectAll, setSelectAll] = useState(false); // Estado para controlar si se seleccionan/desmarcan todas las filas

  const [show, setShow] = useState({ mensaje: false });
  const handleClose = (e) => {
    setShow(false);
  };

  useEffect(() => {
    Promise.all([
      getPuestos(params.idCon, params.idSol),
      getPuestosSeleccionados(params.idCon, params.idSol) // Obtén los puestos seleccionados
    ]).then(([puestosData, puestosSeleccionadosData]) => {
      setPuestos(puestosData);

      // Procesa los puestos seleccionados y combínalos con los datos generales
      const selected = puestosSeleccionadosData.map((seleccionado, index) => {
        // Busca el puesto correspondiente en la lista de puestos
        const puesto = puestosData.find(p => p.xpt === seleccionado.xpt);
        if (puesto) {
          return { row: puesto, order: index + 1 }; // Incluye orden basado en el índice
        }
        return null; // Excluye los datos no encontrados
      }).filter(Boolean); // Elimina valores nulos

      setSelectedRows(selected); // Actualiza los puestos seleccionados
      setLoading(false);
    });
  }, [params.idCon, params.idSol]);

  // Función para manejar la selección de filas individualmente
  const handleCheckboxChange = (row, checked) => {
    setSelectedRows((prevSelectedRows) => {
      if (checked) {
        // Añadir fila seleccionada
        return [...prevSelectedRows, { row, order: prevSelectedRows.length + 1 }];
      } else {
        // Remover fila deseleccionada y reasignar órdenes
        const updatedRows = prevSelectedRows.filter(
          (selected) => selected.row !== row
        );
        return updatedRows.map((selected, index) => ({
          ...selected,
          order: index + 1,
        }));
      }
    });
  };

  // Función para manejar la selección de todas las filas
  const handleSelectAll = (checked) => {
    setSelectAll(checked); // Actualiza el estado del checkbox general
    if (checked) {
      // Si el checkbox general está marcado, selecciona todas las filas
      const allSelectedRows = puestos.map((row, index) => ({
        row,
        order: index + 1,
      }));
      setSelectedRows(allSelectedRows);
    } else {
      // Si está desmarcado, deselecciona todas las filas
      setSelectedRows([]);
    }
  };

  // Definir las columnas para la tabla
  const columnas = [
    {
      name: (
        <input
          type="checkbox"
          className="form-check-input m-1 p-1"
          checked={selectAll} // Controla el estado del checkbox general
          onChange={(e) => handleSelectAll(e.target.checked)} // Maneja el evento de selección/desmarcar todo
        />
      ),
      selector: (row) => (
        <input
          type="checkbox"
          className="form-check-input m-1 p-1"
          checked={selectedRows.some((selected) => selected.row === row)}
          onChange={(e) => handleCheckboxChange(row, e.target.checked)}
        />


      )

    },
    {
      name: "Preferencia",
      selector: (row) => {
        const selectedRow = selectedRows.find((selected) => selected.row === row);
        const order = selectedRow ? selectedRow.order : null;

        return (
          <div className="ordenAct row">
            <div className="col-8">
              <input
                type="number"
                min={1}
                className="form-control"
                value={order || ""}
                readOnly // Solo lectura, ya que el orden lo asignamos automáticamente
              />
            </div>
          </div>
        );
      },
      grow: 1.5
    },

  ];

  const [filtro, setFiltro] = useState("");
  const [listaFiltrada, setListaFiltrada] = useState([]);

  useEffect(() => {
    if (puestos) {
      const texto = filtro.toLowerCase();

      const resultado = puestos.filter(item => {

        // Columna 2 completa (concatenada)
        const columna2 = `
        ${(item.xpt).toString() ?? ""}
        ${item.dpt ?? ""}
        ${item.consejeria ?? ""}
        ${item.cdirectivo ?? ""}
        ${item.tipoplaza ?? ""}
      `.toLowerCase();

        // Columna 3: complemento específico
        const complemento = (item.sclacmp ?? "").toString().toLowerCase();

        // Columna 4: localización
        const localizacion = `
        ${item.dmunicipio ?? ""}
        ${item.dprovincia ?? ""}
        ${item.localiz ?? ""}
      `.toLowerCase();

        //Columna 5: Nivel
        const nivel = (item.nivel ?? "").toString().toLowerCase();

        return (
          columna2.includes(texto) ||
          complemento.includes(texto) ||
          localizacion.includes(texto) ||
          nivel.includes(texto)
        );
      });

      setListaFiltrada(resultado);
    }
  }, [filtro, puestos]);

  return (<>
    <Header />
    <div className="containerSeleccionPuestos" role="main" data-landmark-index="4">
      {/*<Titulo
        tipo={"tituloPagina"}
        titulo={`Selección de Puestos`}
      />*/}
      <h2 className="tituloPagina">Selección de Puestos</h2>
      <div className="mensajeInfo fondo">
        <p>
          Ahora puede indicar cuáles son sus preferencias de puestos,
          haciendo click para marcar los puestos elegidos y cumplimentando
          el orden de preferencia de cada uno.
        </p>
      </div>
      {loading ? (
        <p>Cargando...</p>
      ) : (
        <div className="contTabla mt-5 d-flex flex-column justify-content-center">
          <div className="container row buscadorPuestos">
            <div className="col-md-3 position-relative">
              <input
                type="text"
                className="form-control pe-5"
                placeholder="Busca un puesto..."
                value={filtro}
                onChange={(e) => setFiltro(e.target.value)}
              />
              <i
                className="fa fa-search position-absolute"
                style={{
                  right: "20px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: "#aaa",
                  pointerEvents: "none"
                }}
              ></i>
            </div>
          </div>
          <div className="container tablaPuestos card">
            <DataTable
              className="table-responsive"
              columns={[...columnas, ...ConstantesTabla.columnasTablaSeleccionPuestos]}
              data={listaFiltrada}
              pagination
              paginationComponentOptions={ConstantesTabla.paginacionOpt}
              noDataComponent={<span>No se encontraron puestos</span>}
              customStyles={ConstantesTabla.customStyles}
              width="auto"
              fixedHeader

              subHeaderWrap={true}
              style={{ marginTop: "20px" }}
            />
          </div>
        </div>
      )}
      {/* <div className="buttons">
        <Button
          clases={"rounded"}
          nombre={"Grabar"}
          funcion={() => {
            // if (puestosAenviar.length !== 0) {
            //   if (
            //     localStorage.getItem("puestosSeleccionados") === null
            //   ) {
            //     localStorage.setItem(
            //       "puestosSeleccionados",
            //       JSON.stringify(puestosAenviar)
            //     );
            //   } else {
            //     let puestosJson = JSON.parse(
            //       localStorage.getItem("puestosSeleccionados")
            //     );
            //     puestosJson = puestosJson.concat(puestosAenviar);
            //     localStorage.setItem(
            //       "puestosSeleccionados",
            //       JSON.stringify(puestosJson)
            //     );
            //   }
            //   navigate(`consModSolicitudes/${params.idCon}/${params.idSol}`, {state:{adscripcion:adscripcion}});
            // } else {
            //   setShow({
            //     mensaje: true,
            //     content: "Debe seleccionar un puesto",
            //     tipo: "tituloModal",
            //     destinoCerrar: null,
            //   });
            // }
            
            

            guardarOrdenPuestos(selectedRows, params).then((data) => {
              
              if (selectedRows.length !== 0) {
                setShow({
                  mensaje: true,
                  content: "Puestos enviados correctamente.",
                  contentBold: "",
                  tipo: "tituloModal",
                  aviso: true,
                  destinoAviso: null,
                  destinoCerrar: null,
                });
              } else {
                setShow({
                  mensaje: true,
                  enviado: true,
                  content: "No hay puestos disponibles.",
                  contentBold: "",
                  tipo: "tituloModal",
                  aviso: true,
                  destinoAviso: null,
                  destinoCerrar: null,
                });
              }
            })
          }}
        />
      </div> */}
      <div className=" buttons d-flex justify-content-center gap-3 mt-4 row">
        {/* Botón Cancelar */}
        <div className="col-md-5 col-12 order-2 order-md-1">
          <button
            type="button"
            className="btnRed rounded botonVolverAnexoI1"
            onClick={() =>
             navigate(`/consModSolicitudes/${params.idCon}/${params.idSol}`)
            }
          >
            <i className="fa-solid fa-rotate-left"></i> Volver
          </button>
        </div>

        {/* Botón Guardar borrador */}
        <div className="col-md-5 col-12 order-1 order-md-2">
          <button
            type="submit"
            className="btn btn-primary botonGuardarAnexoI1"
            // disabled={cargaBoton}
            onClick={() => {
              
              guardarOrdenPuestos(selectedRows, params).then((data) => {
              
              if (selectedRows.length !== 0) {
                setShow({
                  mensaje: true,
                  content: "Puestos enviados correctamente.",
                  contentBold: "",
                  tipo: "tituloModal",
                  aviso: true,
                  destinoAviso: null,
                  destinoCerrar: null,
                });
              } else {
                setShow({
                  mensaje: true,
                  enviado: true,
                  content: "No hay puestos disponibles.",
                  contentBold: "",
                  tipo: "tituloModal",
                  aviso: true,
                  destinoAviso: null,
                  destinoCerrar: null,
                });
              }
            })
          

              
            }}>

                Grabar
            
          </button>

        </div>




      </div>
    </div>
    <Footer />
    {show.mensaje ? (
      <ModalMensajes
        show={show.mensaje}
        handleClose={handleClose}
        texto={show?.content}
        tipo={show?.tipo}
        destinoCerrar={show?.destinoCerrar}
      ></ModalMensajes>
    ) : null}
  </>);
};

export default SeleccionPuestos;
